import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import axios from 'axios';
import qs from 'qs';
import 'vant/lib/index.css';
import 'amfe-flexible'
import 'lib-flexible/flexible.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'
import "@/assets/font/font.css"
import Swiper from '@/components/swiper.vue'
import Api from "@/api/request.js";
Vue.component('Swiper', Swiper)
Vue.prototype.$api = Api;
Vue.prototype.$axios = axios
Vue.prototype.$qs = qs
Vue.use(less)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.config.productionTip = false
router.afterEach((to, from, next) => {

  window, scrollTo(0, 0)

})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
